import { render, staticRenderFns } from "./OrdersListing.vue?vue&type=template&id=615ca1b2&scoped=true"
import script from "./OrdersListing.vue?vue&type=script&lang=ts"
export * from "./OrdersListing.vue?vue&type=script&lang=ts"
import style0 from "./OrdersListing.vue?vue&type=style&index=0&id=615ca1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ca1b2",
  null
  
)

export default component.exports